// Import components
import './action-download';
import './action-duplicate';
import './action-move-to-trash';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-quick-actions' )
export class AutomatorBuilderPublishQuickActions extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="quick-actions">
				<uap-builder-publish-quick-action-move-to-trash></uap-builder-publish-quick-action-move-to-trash>
				<uap-builder-publish-quick-action-duplicate></uap-builder-publish-quick-action-duplicate>
				<uap-builder-publish-quick-action-download></uap-builder-publish-quick-action-download>
			</div>
		`;
	}
}